import React, { useContext } from 'react'
import styled from 'styled-components'

import BodyText from 'components/Luxkit/Typography/BodyText'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import Image from 'components/Common/Image'
import TextLink from 'components/Luxkit/TextLink'
import { mediaQueryUp } from 'components/utils/breakpoint'
import ContactContext from 'contexts/contactContext'
import Group from 'components/utils/Group'
import { useScreenSizeOnly } from 'hooks/useScreenSize'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyFeatureFlags } from 'constants/optimizely'
import ModalContext from 'contexts/ModalContext'
import RequestAgentCallbackModal from 'supportAssistant/components/RequestAgentCallback/Modals/RequestAgentCallbackModal'
import LineIncomingCallIcon from 'components/Luxkit/Icons/line/LineIncomingCallIcon'
import GeoContext from 'contexts/geoContext'
import { getCustomerSupportAgentImage } from 'components/Common/CustomerSupport/getAgentImage'
import { rem } from 'polished'

const ImageWrapper = styled.div`
  min-width: ${rem(68)};
  height: ${rem(68)};

  ${mediaQueryUp.tablet} {
    min-width: ${rem(84)};
    height: ${rem(84)};
  }
`
interface Props {
  className?: string;
  allowsAgentCallbackRequest?: boolean
}

function ContactUSP({ className, allowsAgentCallbackRequest }: Props) {
  const isMobileScreen = useScreenSizeOnly('mobile')
  const currentContact = useContext(ContactContext)
  const { currentRegionCode } = useContext(GeoContext)
  const contact = currentContact.defaultContact
  const customerSupportImage = getCustomerSupportAgentImage('left', false, currentRegionCode)
  const callbacksFeatureEnabled = !!useOptimizelyExperiment(OptimizelyFeatureFlags.toursRequestAgentCallbackEnabled)

  const showModal = useContext(ModalContext)

  const handleCallbackClick = () => { showModal(<RequestAgentCallbackModal type="TOURS"/>) }

  return (
    <Group
      className={className}
      gap={16}
      tabletGap={20}
      direction="horizontal-reverse"
      tabletDirection="horizontal"
      verticalAlign="start"
      tabletVerticalAlign="center"
      horizontalAlign="space-between"
      tabletHorizontalAlign="start"
    >
      <ImageWrapper>
        <Image fit="top" id={customerSupportImage} quality="best" width={isMobileScreen ? 68 : 84} />
      </ImageWrapper>
      <Group direction="vertical" gap={4}>
        <BodyText variant="medium" weight="bold">
          Our team are available 24 hours, 7 days
        </BodyText>
        <BodyText variant="medium" colour="neutral-three">
          Interested in this offer? Contact our dedicated support team anytime.
        </BodyText>
        <Group direction="horizontal" gap={32}>
          <TextLink
            size="medium"
            weight="bold"
            href={`tel:${contact.number}`}
            startIcon={<LinePhoneIcon />}
          >
            {contact.humanReadable}
          </TextLink>
          {callbacksFeatureEnabled && allowsAgentCallbackRequest && <TextLink
            size="medium"
            weight="bold"
            onClick={handleCallbackClick}
            startIcon={<LineIncomingCallIcon/>}
          >
            Request a callback
          </TextLink>
          }
        </Group>
      </Group>
    </Group>
  )
}

export default ContactUSP
